const { isUndefined } = require('lodash');
const { planTypes, DEFAULT_MIN_HOST } = require('@/common/constants');

export const isDIDPlan = (plan) => plan.type === planTypes.TOLLFREE$DID;

export function getDIDPlanConfig(boughtPlans) {
  const types = [planTypes.TOLLFREE$DID, planTypes.TOLLFREE];
  const plan = boughtPlans.find((p) => types.includes(p.type) && !isUndefined(p.cartInfo.tollfree_apac_hosts));
  const cartInfo = plan ? plan.cartInfo : {};
  const { tollfree_apac_hosts, tollfree_apac_cancelled, tollfree_apac_isOnlineCancel } = cartInfo;
  return {
    tollfree_apac_hosts,
    tollfree_apac_cancelled,
    tollfree_apac_isOnlineCancel,
    selectedNumber: Math.max(tollfree_apac_hosts || DEFAULT_MIN_HOST, DEFAULT_MIN_HOST),
    isCancelled: !!tollfree_apac_cancelled,
    hasCancellationRecord: !!tollfree_apac_isOnlineCancel,
  };
}
